import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";
import { api } from "../lib/api";

/** Anonymous, privacy-friendly page-view tracker.
 *  - Generates a stable random `visitor_id` once per device (localStorage).
 *  - Fires `/api/track/view` on every route change.
 *  - No IPs, no fingerprinting — just an aggregate counter per page.
 *  - Skips /admin to avoid skewing the analytics with your own visits.
 */
const useVisitTracker = () => {
  const { pathname } = useLocation();
  const { lang } = useLanguage();

  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin")) return;

    // Stable anonymous visitor id (one per device, never expires)
    let visitorId = localStorage.getItem("icc_visitor_id");
    if (!visitorId) {
      visitorId = "v_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem("icc_visitor_id", visitorId);
    }

    // Fire-and-forget tracking — never block UI on this
    api.post("/track/view", { path: pathname, visitor_id: visitorId, lang })
      .catch(() => {});
  }, [pathname, lang]);
};

export default useVisitTracker;
